<div class="catalog-filters-bottom-sheet">
  <!-- Header -->
  <div class="catalog-filters-bottom-sheet__header">
    <h2 class="catalog-filters-bottom-sheet__title">
      Filters & Sort
    </h2>
    <button
      class="catalog-filters-bottom-sheet__close-button"
      (click)="close()"
      aria-label="Close">
      <img
        src="/assets/images/icons/close-icon-mobile.svg"
        alt="Close"
        class="catalog-filters-bottom-sheet__close-icon"
      />
    </button>
  </div>

  <!-- Content -->
  <div class="catalog-filters-bottom-sheet__content">

    <!-- Sort By Section -->
    <div class="catalog-filters-bottom-sheet__section" *ngIf="hasSortItems()">
      <app-criteria-selector
        [icon]="'/assets/images/icons/sort-by-icon.svg'"
        [title]="'charity_catalog.sort.title'"
        [items]="sortItems()"
        [multiSelect]="false"
        [variant]="'default'"
        (selectionChanged)="onSortChanged($event)">
      </app-criteria-selector>
    </div>

    <!-- Filters Section -->
    <div class="catalog-filters-bottom-sheet__section">
      <div class="catalog-filters-bottom-sheet__filter-header">
        <img
          src="/assets/images/icons/filter-icon.svg"
          alt=""
          class="catalog-filters-bottom-sheet__icon"
        />
        <p class="catalog-filters-bottom-sheet__filter-title">
          {{ 'charity_catalog.filter.title' | translateLang }}
        </p>
      </div>

      <div class="catalog-filters-bottom-sheet__dropdown-list">
        <!-- Address Filter (ORGANISATION only) -->
        <ng-container *ngIf="hasAddressItems()">
          <app-criteria-selector
            [dropdownTitle]="'charity_catalog.filter.address'"
            [showMainTitle]="false"
            [items]="addressItems()"
            [multiSelect]="true"
            [variant]="'dropdown'"
            [initialExpanded]="false"
            (selectionChanged)="onAddressChanged($event)">
          </app-criteria-selector>

          <div class="catalog-filters-bottom-sheet__divider"></div>
        </ng-container>

        <!-- Country Filter -->
        <ng-container *ngIf="hasCountryItems()">
          <app-criteria-selector
            [dropdownTitle]="'charity_catalog.filter.country'"
            [showMainTitle]="false"
            [items]="countryItems()"
            [multiSelect]="true"
            [variant]="'dropdown'"
            [initialExpanded]="false"
            (selectionChanged)="onCountryChanged($event)">
          </app-criteria-selector>

          <div class="catalog-filters-bottom-sheet__divider"></div>
        </ng-container>

        <!-- Region Filter -->
        <ng-container *ngIf="hasRegionItems()">
          <app-criteria-selector
            [dropdownTitle]="'charity_catalog.filter.region'"
            [showMainTitle]="false"
            [items]="regionItems()"
            [multiSelect]="true"
            [variant]="'dropdown'"
            [initialExpanded]="false"
            (selectionChanged)="onRegionChanged($event)">
          </app-criteria-selector>

          <div class="catalog-filters-bottom-sheet__divider"></div>
        </ng-container>

        <!-- Cause Filter -->
        <ng-container *ngIf="hasCauseItems()">
          <app-criteria-selector
            [dropdownTitle]="'charity_catalog.filter.cause'"
            [showMainTitle]="false"
            [items]="causeItems()"
            [multiSelect]="true"
            [variant]="'dropdown'"
            [initialExpanded]="false"
            (selectionChanged)="onCauseChanged($event)">
          </app-criteria-selector>

          <div class="catalog-filters-bottom-sheet__divider"></div>
        </ng-container>

        <!-- Category Filter -->
        <ng-container *ngIf="hasCategoryItems()">
          <app-criteria-selector
            [dropdownTitle]="'charity_catalog.filter.category'"
            [showMainTitle]="false"
            [items]="categoryItems()"
            [multiSelect]="true"
            [variant]="'dropdown'"
            [initialExpanded]="false"
            (selectionChanged)="onCategoryChanged($event)">
          </app-criteria-selector>

          <div class="catalog-filters-bottom-sheet__divider"></div>
        </ng-container>

        <!-- Champions Filter -->
        <ng-container *ngIf="hasChampionsItems()">
          <app-criteria-selector
            [dropdownTitle]="'charity_catalog.filter.champions'"
            [showMainTitle]="false"
            [items]="championsItems()"
            [multiSelect]="true"
            [variant]="'dropdown'"
            [initialExpanded]="false"
            (selectionChanged)="onChampionsChanged($event)">
          </app-criteria-selector>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Footer with Buttons -->
  <div class="catalog-filters-bottom-sheet__footer">
    <button class="catalog-filters-bottom-sheet__clear-button" (click)="clearAllFilters()">
      Clear All Filters
    </button>
    <button class="catalog-filters-bottom-sheet__apply-button" (click)="applyFilters()">
      Apply Filter
    </button>
  </div>
</div>
